import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import ReservationFlow from './ReservationFlow';

const ReservationFlowWrapper = (props) => (
  <Router basename='/'>
    <ReservationFlow {...props} />
  </Router>
);

export default ReservationFlowWrapper;
